import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakLoginOptions, KeycloakProfile, KeycloakTokenParsed,KeycloakInstance } from 'keycloak-js';
import { from, Observable } from 'rxjs';
import { promise } from 'selenium-webdriver';
import { environment } from 'src/environments/environment';

@Injectable()
export class keyService {

  constructor(private keycloakService: KeycloakService) {}

  public getLoggedUser(): KeycloakTokenParsed | undefined {
    try {
      const userDetails: KeycloakTokenParsed | undefined = this.keycloakService.getKeycloakInstance()
        .idTokenParsed;
        
      return userDetails;
    } catch (e) {
      return undefined;
    }
  }

  public isLoggedIn() : Promise<boolean> {
    return this.keycloakService.isLoggedIn();
  }

  public loadUserProfile() : Promise<KeycloakProfile> {
    return this.keycloakService.loadUserProfile();
  }

  public login() : void {
    const option:KeycloakLoginOptions = {
      redirectUri:`${environment.baseUrl}/login`
    }
    this.keycloakService.login(option);
  }

  public logout() : void {
    this.keycloakService.logout(window.location.origin);
  }

  public redirectToProfile(): void {
    this.keycloakService.getKeycloakInstance().accountManagement();
  }

  public getRoles(): string[] {
    return this.keycloakService.getUserRoles();
  };
  getToken(): Promise<string>{
   
    return this.keycloakService.getToken();
  };
  istokenExpired(){
    return this.keycloakService.isTokenExpired()
  }
}
